import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/hero-1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/img/en/dashboard-en.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/img/en/hero-image-en.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/img/es/dashboard-es.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/img/es/hero-image-es.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/img/pt/dashboard-pt.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/img/pt/hero-image-pt.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/shared/basics/RedirectToExternalLinkButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FAQSection"] */ "/vercel/path0/src/components/shared/FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Reviews"] */ "/vercel/path0/src/components/shared/Reviews.tsx");
